import { AxiosResponse } from 'axios';
import { getAxiosSecureInstance } from '../../utilities/AxiosClient';

export type NotificationModel = {
  id: string;
  userId: string;
  type: string;
  isRead: boolean;
  email: string;
  content: any;
};

export type NotificationAction = {
  action: string;
  notification: NotificationModel;
};

export function getNotifications(page: number, pageSize: number): Promise<AxiosResponse<NotificationModel[]>> {
  return getAxiosSecureInstance().get(`/api/notifications?page=${page}&pageSize=${pageSize}`);
}

export function doActionNotification(
  notificationAction: NotificationAction,
): Promise<AxiosResponse<NotificationModel>> {
  return getAxiosSecureInstance().post(`/api/notifications`, notificationAction);
}

export function readNotifications(notificationIds: string[]): Promise<AxiosResponse<number>> {
  return getAxiosSecureInstance().post(`/api/notifications/read`, notificationIds);
}

export function getUnreadNotificationCount(): Promise<AxiosResponse<number>> {
  return getAxiosSecureInstance().get(`/api/notifications/unread-count`);
}
